export const SUPPORTED_COUNTRIES = [
  { code: "CA", name: "Canada" },
  { code: "GH", name: "Ghana" },
  { code: "HT", name: "Haiti" },
  { code: "IN", name: "India" },
  { code: "KE", name: "Kenya" },
  { code: "NP", name: "Nepal" },
  { code: "NG", name: "Nigeria" },
  { code: "PK", name: "Pakistan" },
  { code: "PH", name: "Philippines" },
  { code: "PR", name: "Puerto Rico" },
  { code: "KR", name: "South Korea" },
  { code: "US", name: "United States" }
] as const;

export type SupportedCountry = (typeof SUPPORTED_COUNTRIES)[number];
export type SupportedCountryCode = SupportedCountry["code"];

export const COUNTRY_NAME_BY_CODE = Object.freeze(
  Object.fromEntries(SUPPORTED_COUNTRIES.map(({ code, name }) => [code, name]))
) as Readonly<Record<SupportedCountryCode, string>>;

export function getCountryName(countryCode: string): string {
  const normalizedCode = countryCode.trim().toUpperCase() as SupportedCountryCode;
  return COUNTRY_NAME_BY_CODE[normalizedCode] ?? countryCode;
}
